import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
// import {
//   User,
//   Lock,
//   Eye,
//   EyeOff,
//   Stethoscope,
//   RefreshCw,
//   Calculator,
//   ArrowRight,
//   HeartPulse,
//   BedDouble,
//   Building2,
//   ShieldCheck,
// } from "lucide-react";
// import api from "./adminApi";
// import PulseLine from "./PulseLine";
import {
  User,
  Lock,
  Eye,
  EyeOff,
  Stethoscope,
  RefreshCw,
  Calculator,
  ArrowRight,
  ShieldCheck,
} from "lucide-react";
import api from "./adminApi";
import PulseLine from "./PulseLine";
import "./admin.css";

const fieldVariants = {
  hidden: { opacity: 0, y: 14 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: 0.15 + i * 0.08, duration: 0.5, ease: "easeOut" },
  }),
};

export default function AdminLogin() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [question, setQuestion] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const loadCaptcha = async () => {
    try {
      const res = await api.get("/admin/auth/captcha");
      setQuestion(res.data.question);
      setCaptchaToken(res.data.token);
      setCaptchaAnswer("");
    } catch {
      setQuestion("");
      setCaptchaToken("");
    }
  };

  useEffect(() => {
    loadCaptcha();
  }, []);

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  if (!userId || !password || captchaAnswer === "") {
    setError("Please fill in User ID, Password and the security check.");
    return;
  }

  setLoading(true);

  try {
    const res = await api.post("/admin/auth/login", {
      userId,
      password,
      captcha: captchaAnswer,
      captchaToken,
    });

    localStorage.setItem("mkcg_admin_token", res.data.token);
    localStorage.setItem("mkcg_admin_user", JSON.stringify(res.data.user));

    navigate("/admin/dashboard");

  } catch (err) {
    console.log("Error:", err);
    console.log("Response:", err.response);
    console.log("Data:", err.response?.data);

    setError(
      err.response?.data?.message ||
      err.message ||
      "Something went wrong."
    );

    loadCaptcha();

  } finally {
    setLoading(false);
  }
};

  return (
    <div className="mkcg-admin min-h-screen w-full flex relative overflow-hidden" style={{ background: "#f4f7fb" }}>

      
      {/* ── Left: institutional panel (hidden on small screens) ───────────── */}
      <div className="hidden lg:flex lg:w-[46%] xl:w-1/2 relative bg-navy overflow-hidden flex-col items-center justify-center p-12 xl:p-14">
        {/* Secure Access badge — top-right corner of the panel */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="hidden xl:flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-semibold tracking-wide absolute top-12 right-12 xl:top-14 xl:right-14 z-[1]"
          style={{ background: "rgba(59, 182, 242, 0.15)", color: "rgb(142, 246, 251)", border: "1px solid rgb(142, 246, 251)" }}
        >
          <ShieldCheck size={13} />
          Secure Access
        </motion.div>
        {/* ambient glow accents */}
        <div className="absolute -top-24 -left-24 w-80 h-80 bg-teal/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[26rem] h-[26rem] bg-navy-light/70 rounded-full blur-3xl translate-x-1/4 translate-y-1/4" />
        <div className="absolute top-1/3 right-10 w-56 h-56 rounded-full blur-3xl"  />
        <div className="absolute imgs inset-0 opacity-[0.06]" style={{
          backgroundSize: "26px 26px",
        }} />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="relative flex flex-col items-center text-center max-w-sm"
        >
          <img
            src="/favicon.svg"
            alt="MKCG Medical College logo"
            className="w-32 h-32 xl:w-36 xl:h-36 mb-6 drop-shadow-2xl"
          />
          <p className="text-teal-light text-xs font-medium tracking-[0.2em] uppercase mb-4">
            Staff &amp; Administration Portal
          </p>
          <p
            className="text-white font-semibold text-xl xl:text-[26px] leading-snug mb-3"
            style={{ fontFamily: "'Noto Sans Oriya', 'Noto Sans', sans-serif" }}
          >
            ମହାରାଜା କୃଷ୍ଣଚନ୍ଦ୍ର ଗଜପତି ଭେଷଜ ମହାବିଦ୍ୟାଳୟ, ବ୍ରହ୍ମପୁର
          </p>
          <p className="text-teal-light font-display font-medium text-base xl:text-lg tracking-wide leading-snug mb-6">
            Maharaja Krushna Chandra Gajapati Medical College, Berhampur
          </p>
         <div className="drop-shadow-[0_0_14px_rgba(94,234,212,0.6)]">
            <PulseLine className="w-56" color="#5EEAD4" height={32} />
          </div>
        </motion.div>
      </div>

      {/* ── Right: login form ──────────────────────────────────────────────── */}
      <div className="imgss flex-1 flex items-center justify-center px-6 py-10 relative">
        {/* subtle ambient accents behind the card */}
        <div className="absolute top-0 right-0 w-[30rem] h-[30rem] rounded-full blur-3xl pointer-events-none"
             style={{ background: "radial-gradient(circle, rgba(94,234,212,0.14), transparent 65%)" }} />
        <div className="absolute bottom-0 left-0 w-[24rem] h-[24rem] rounded-full blur-3xl pointer-events-none"
             style={{ background: "radial-gradient(circle, rgba(242,169,59,0.10), transparent 65%)" }} />

        <div className="lg:hidden absolute top-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-[1]">
          <div className="w-9 h-9 rounded-lg bg-navy flex items-center justify-center">
            <Stethoscope className="text-teal-light" size={18} />
          </div>
          <span className="font-display font-semibold text-navy text-sm">MKCG Hospital</span>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="w-full max-w-[420px] relative z-[1] bg-white rounded-3xl border border-slate-100 
		  shadow-2xl shadow-navy/10 px-8 py-9 sm:px-10 sm:py-10" 
        style={{ padding: "16px 50px" }}>
          <div className="flex flex-col items-center text-center mb-8" >
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4 shadow-lg shadow-navy/10"
                 style={{ background: "linear-gradient(135deg,#0B2545,#0EA5A4)" }}>
              <Lock className="text-white" size={22} />
            </div>
            <h2 className="font-display font-bold text-2xl text-navy tracking-tight">User Login</h2>
            {/* <p className="text-sm text-slate-400 mt-1.5">Sign in to your staff account to continue.</p> */}
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" style={{ marginBottom: "10px" }}>
            <motion.div custom={0} variants={fieldVariants} initial="hidden" animate="show">
              <label className="text-xs font-semibold text-slate-500 mb-1.5 block">User ID</label>
              <div className="mkcg-input-box flex items-center gap-2.5 bg-white border border-slate-200 rounded-xl px-3.5 focus-within:border-teal focus-within:ring-4 focus-within:ring-teal/10 transition-all">
                <User size={18} className="text-slate-400 shrink-0" />
                <input
                  type="text"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  placeholder="Enter your user ID"
                  className="w-full py-3 border-none outline-none ring-0 focus:outline-none focus:ring-0 text-sm font-mono text-slate-ink bg-transparent"
                  autoComplete="username"
                />
              </div>
            </motion.div>

            <motion.div custom={1} variants={fieldVariants} initial="hidden" animate="show">
              <label className="text-xs font-semibold text-slate-500 mb-1.5 block">Password</label>
              <div className="mkcg-input-box flex items-center gap-2.5 bg-white border border-slate-200 rounded-xl px-3.5 focus-within:border-teal focus-within:ring-4 focus-within:ring-teal/10 transition-all">
                <Lock size={18} className="text-slate-400 shrink-0" />
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="w-full py-3 border-none outline-none ring-0 focus:outline-none focus:ring-0 text-sm text-slate-ink bg-transparent"
                  autoComplete="current-password" style={{ background: "transparent", color: "#555252"}}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((s) => !s)}
                  className="text-slate-400 hover:text-slate-600 shrink-0 border-none outline-none ring-0 focus:outline-none focus:ring-0 focus:border-none"
                  tabIndex={-1}
                >
                  {showPassword ? <EyeOff size={17} /> : <Eye size={17} />}
                </button>
              </div>
            </motion.div>

            {/* Security check — custom tile-style math captcha */}
            <motion.div custom={2} variants={fieldVariants} initial="hidden" animate="show">
              <label className="text-xs font-semibold text-slate-500 mb-1.5 block">Security check</label>
              <div className="flex items-center gap-3 bg-gradient-to-br from-navy to-navy-light rounded-xl px-4 py-3 shadow-lg shadow-navy/10">
                <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
                  <Calculator size={16} className="text-teal-light" />
                </div>
                <AnimatePresence mode="wait">
                  <motion.span
                    key={question}
                    initial={{ opacity: 0, x: 6 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -6 }}
                    transition={{ duration: 0.2 }}
                    className="font-mono text-white text-lg font-semibold tracking-wide"
                  >
                    {question || "· · ·"}
                  </motion.span>
                </AnimatePresence>
                <span className="text-white/40 text-sm">=</span>
                <input
                  type="text"
                  inputMode="numeric"
                  value={captchaAnswer}
                  onChange={(e) => setCaptchaAnswer(e.target.value)}
                  placeholder="?"
                  className="w-16 bg-white/10 focus:bg-white/15 rounded-lg text-center py-1.5 text-white font-mono text-sm outline-none placeholder-white/30 transition"
                  autoComplete="off"
                />
                <button
                  type="button"
                  onClick={loadCaptcha}
                  className="ml-auto w-8 h-8 rounded-lg bg-white/10 hover:bg-white/20 text-teal-light hover:text-white flex items-center justify-center transition shrink-0"
                  title="New question"
                >
                  <RefreshCw size={15} />
                </button>
              </div>
            </motion.div>

            <AnimatePresence>
              {error && (
                <motion.p
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2"
                >
                  {error}
                </motion.p>
              )}
            </AnimatePresence>

            <motion.button
              custom={3}
              variants={fieldVariants}
              initial="hidden"
              animate="show"
              type="submit"
              disabled={loading}
              whileHover={{ y: -1 }}
              whileTap={{ scale: 0.98 }}
              className="w-full flex items-center justify-center gap-2 text-white font-semibold rounded-xl py-3.5 transition disabled:opacity-60 disabled:cursor-not-allowed shadow-lg shadow-teal/25"
              style={{ background: "linear-gradient(120deg,#0B2545 0%,#0EA5A4 100%)", padding: "6px" }}
            >
              {loading ? "Signing in..." : "Sign In"}
              {!loading && <ArrowRight size={16} />}
            </motion.button>
          </form>
{/* 
          <p className="text-center text-xs text-slate-400 mt-8">
            Maharaja Krushna Chandra Gajapati Medical College & Hospital, Berhampur, Odisha
          </p> */}
          {/* <button
                  type="button"
                  onClick={() => navigate("/admin/forgot-password")}
                  className="text-xs font-semibold text-teal hover:text-navy transition" style={{ color: "red" }}
                >
                  Forgot password?
            </button> */}
          
  <button
    type="button"
    onClick={() => navigate("/admin/forgot-password")}
    className="text-sm font-semibold text-red-600 hover:text-red-700 transition-colors duration-200 bg-transparent border-none outline-none focus:outline-none" style={{margin: "0 auto", width: "100%"}}
  >
    Forgot password?
  </button>

        </motion.div>
      </div>
    </div>
  );
}
